import { render, staticRenderFns } from "./ProgressColored.vue?vue&type=template&id=8b22e1fa&"
import script from "./ProgressColored.vue?vue&type=script&lang=js&"
export * from "./ProgressColored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports